import { render, staticRenderFns } from "./SidebarItems.vue?vue&type=template&id=2c8b7640&scoped=true&"
import script from "./SidebarItems.vue?vue&type=script&lang=js&"
export * from "./SidebarItems.vue?vue&type=script&lang=js&"
import style0 from "./SidebarItems.vue?vue&type=style&index=0&id=2c8b7640&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8b7640",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VListGroup,VListItem,VListItemIcon,VListItemTitle,VTooltip})
